module.exports = __webpack_public_path__ + "img/cashier-service-03.fb20e4ec.png";